import { useSearchParams } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { ChatPanel } from "@/components/ChatPanel";

const SafetyNote = ({ className }) => (
  <div className={`gap-3 text-xs sm:text-sm text-slate-400 border border-[#27303E] p-3 sm:p-4 rounded-sm ${className}`}>
    <ShieldAlert className="text-red-400 shrink-0" size={18} />
    For brake failure, fuel leaks, smoke or overheating, stop driving and contact a professional immediately.
  </div>
);

export default function AskMechanic() {
  const [params] = useSearchParams();
  return (
    <main className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pt-4 pb-6 sm:py-14 grid lg:grid-cols-[1fr_2fr] gap-4 sm:gap-10" data-testid="ask-page">
      <aside className="px-1 sm:px-0">
        <p className="hidden sm:block font-mono text-xs uppercase tracking-widest text-amber-500">AI Diagnostic Bay</p>
        <h1 className="font-display text-[1.9rem] sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.95] sm:mt-3">
          Ask the <span className="text-amber-500">AI mechanic</span>
        </h1>
        <p className="hidden sm:block text-slate-400 mt-5 leading-relaxed">
          Powered by Claude and ChatGPT - switch models any time. Describe noises, smells, warning lights or OBD-II codes and get likely causes, DIY steps, cost ranges and when to see a pro. Sign in with Google to keep your chats and Pro on every device.
        </p>
        <img
          src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200"
          alt="Mechanic hands with wrench on engine"
          className="mt-8 w-full h-56 object-cover rounded-sm border border-[#27303E] hidden lg:block"
        />
        <SafetyNote className="hidden sm:flex mt-6" />
      </aside>
      <ChatPanel initialPrompt={params.get("q") || ""} />
      <SafetyNote className="flex sm:hidden" />
    </main>
  );
}
